import { isUserLoggedIn } from '../../utils/authUtils';
import { getPartialModel } from '../../utils/modelUtils';
import { CrudServiceBase } from '../base/crudServiceBase';
import Endpoint from '../endpoint';
import { httpApi } from '../httpService';
import { ReferralAgentDto } from './dto/referralAgentDto';

export class ReferralAgentService extends CrudServiceBase<ReferralAgentDto> {
    constructor() {
        super(Endpoint.ReferralAgent);
        this.internalHttp = httpApi;
    }

    public async create(createReferralAgentInput: ReferralAgentDto) {
        isUserLoggedIn();

        let newCreateReferralAgentInput = getPartialModel(createReferralAgentInput, [], ['id', 'expirationDate', 'token', 'creationTime', 'creatorUserId', 'lastModificationTime', 'lastModifierUserId']);

        let result = await this.internalHttp.post(this.endpoint.Create(), newCreateReferralAgentInput);
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }

    public async update(createReferralAgentInput: ReferralAgentDto) {
        isUserLoggedIn();

        let newCreateReferralAgentInput = getPartialModel(createReferralAgentInput, [], ['expirationDate', 'creationTime', 'creatorUserId', 'lastModificationTime', 'lastModifierUserId']);

        let result = await this.internalHttp.put(this.endpoint.Update(), newCreateReferralAgentInput);
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }
}

const exportReferralAgentService: ReferralAgentService = new ReferralAgentService();
export default exportReferralAgentService;